import React, { useState } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS, GMB_TOPICS } from "constants/PostFormFields";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Notification } from "@/components/ui/notification";

const PostTopicType = ({
  topicType,
  selectedPlatform,
  platforms,
  disabled = false,
  onChange,
  className = "",
  errors,
}) => {
  const [selected, setSelected] = useState(topicType);

  let config = [
    {
      id: 1,
      value: GMB_TOPICS.STANDARD.VALUE,
      label: GMB_TOPICS.STANDARD.LABEL,
    },
    {
      value: GMB_TOPICS.OFFER.VALUE,
      label: GMB_TOPICS.OFFER.LABEL,
    },
    {
      value: GMB_TOPICS.EVENT.VALUE,
      label: GMB_TOPICS.EVENT.LABEL,
    },
    {
      value: GMB_TOPICS.ALERT.VALUE,
      label: GMB_TOPICS.ALERT.LABEL,
    },
  ];

  const handleTopicChange = (item) => {
    setSelected(item);
    onChange({
      [FIELDS.GMB_TOPIC_TYPE]: item,
      ...(item === GMB_TOPICS.OFFER.VALUE ? { [FIELDS.GMB_CTA]: null } : {}),
    });
  };

  return (
    <div data-testid="gmbPostTopicTypeWrapper" className={className}>
      <div className="flex items-center">
        <PostFieldLabel className="mb-2 mr-4">
          Topic type (required)
        </PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.GMB_TOPIC_TYPE}
          selectedPlatform={selectedPlatform}
        />
      </div>
      <p className="small">
        The topic type is the type of GMB post, and you can enter various
        additional information (such as coupon information in offers) based on
        the topic type.
      </p>
      <Select
        value={selected || undefined}
        onValueChange={handleTopicChange}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select a topic…" />
        </SelectTrigger>
        <SelectContent>
          {config.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!topicType && (
        <Notification
          variant="error"
          className="mt-2"
          title="Pick a topic type to enter other GMB values."
        />
      )}
      <PostFieldError
        className="mt-4"
        fields={[FIELDS.GMB_TOPIC_TYPE]}
        errors={errors}
      />
    </div>
  );
};

export default PostTopicType;
